import { forwardRef } from 'react';
import MmuSkuList from '../conponents/MmuSkuList';
import { IProductDetail } from '../product';
import { isCXZQProduct } from '../helper';

type Props = {
  productDetail: IProductDetail;
  shopData: any;
};

// 混凝土清单，手动
function ConcreteProductList({ productDetail, shopData }: Props, ref: any) {
  // 创新专区 & 非混凝土不渲染清单
  if (isCXZQProduct(shopData) || !productDetail.concreteFlag) {
    return (
      <div
        style={{
          height: '24px',
        }}
      />
    );
  }

  // NOTE: 非混凝土商品，不展示商品列表，列表移动到「商品详情」tab组件中

  // NOTE: 目前看来只有「混凝土」商品存在「商品清单」，
  // 清单组件「MmuSkuList」中，表格字段与「混凝土」强相关，操作只有「立即下单」
  return (
    productDetail.useSkuList && (
      <div style={{ padding: '24px 0 0' }}>
        <MmuSkuList skuDetail={productDetail} shop={shopData} ref={ref} />
      </div>
    )
  );
}

export default forwardRef(ConcreteProductList);
